import type { ReactNode } from "react";

export type SettingsRowProps = {
  title: string;
  helper?: string;
  /** Right-side control. */
  children?: ReactNode;
  /** When the control is a single input/select, associate the title <label> with it. */
  htmlFor?: string;
};

/**
 * One row inside a SettingsGroup: label column (title + optional helper) on the
 * left, control on the right. Wraps on mobile so wide controls drop below.
 */
export function SettingsRow({ title, helper, children, htmlFor }: SettingsRowProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-[var(--border)] px-5 py-4 last:border-b-0 sm:flex-nowrap sm:gap-4 sm:px-6">
      <div className="flex-1 basis-[60%]">
        {htmlFor ? (
          <label htmlFor={htmlFor} className="block text-sm font-semibold text-[var(--ink)]">
            {title}
          </label>
        ) : (
          <div className="text-sm font-semibold text-[var(--ink)]">{title}</div>
        )}
        {helper ? <div className="mt-0.5 text-xs text-[var(--ink-faint)]">{helper}</div> : null}
      </div>
      {children}
    </div>
  );
}
